export default __webpack_public_path__ + "static/media/ic_car.b4ec52eb.svg";